import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-follow-us-modal',
  templateUrl: './follow-us-modal.component.html',
  styleUrls: ['./follow-us-modal.component.scss'],
})
export class FollowUsModalComponent implements OnInit {
  constructor(public activeModal: NgbActiveModal, private _router: Router, private userService: UserService) {}

  ngOnInit(): void {}
}
